import React, { Component } from 'react'
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer } from "mobx-react"
import Store from "app/stores/ecs/dataManage"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"

@observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      selecedData: []
    }
  }

  onSelect = (data) => {
    this.setState({
      selectedData: data
    })
  }

  render() {
    const {store} = this
    return (
      <div className="datamanage-page pgs">
         <h2 className="page-title"><img alt="" src={dataIcon} />数据管理</h2>
         <div className="clearfix wrapper-box-first">
            <DataHeader store={store} selectedData={this.state.selectedData} />
        </div>
        <div>
          <DataTable store={store} onSelect={this.onSelect} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/ecs/data_manage/index.js